'use client'
import { type FC } from 'react'
import styled from 'styled-components'
import { Figure } from '../base/Figure'
import { designGrid, font12, mq, vw, createUnderline, font15 } from '@/styles'
import { useTranslator, useDeviceType } from '@/hooks'
import { motion } from 'motion/react'
import { useMount } from '@/hooks'

type TypeAside = {
  isGrid?: boolean
}


export const AsideCTA:FC<TypeAside> = ({ isGrid = false }) => {
  const { t } = useTranslator()
  const { isMobile } = useDeviceType()
  const isMount = useMount()

  return (
    <Aside $isGrid={isGrid}>
      <div>
        <div>
          <Figure media={{ alt: 'Window draw', m: { src: '/images/windows-plant.png', size: { width: 154, height: 158 } } }} />
          <h2>{t('project.aside.exclusive')}</h2>
          {isMount && isMobile && (
            <p dangerouslySetInnerHTML={{ __html: t('project.aside.mobile.book_all') }} />
          )}
          {isMount && !isMobile && (
            <p>
              {t('project.aside.book_all')} <a href='mailto:welcome@portellapalma.com.'>{t('project.aside.write_us')}</a> {t('project.aside.or_call')} <a href='tel:0034871626263'>{t('project.aside.phone')}</a>.
            </p>)
          }
        </div>
      </div>
    </Aside>
  )
}

const Aside = styled(motion.aside)<{ $isGrid: boolean }>`
	background-color: var(--color-background);
  ${designGrid({})}
  margin-top: ${({ $isGrid }) => !$isGrid ? 'unset': `${vw(100, 'mobile')}`};
	z-index: 2;

  ${mq.greaterThan('tablet')} {
    margin-top: ${({ $isGrid }) => !$isGrid ? 'unset': `${vw(150, 'desktop')}`};
  }

  > div {
    display: flex;
    border-top: ${({ $isGrid }) => !$isGrid ? '1px solid rgba(60, 60, 59, 0.15)': 'unset'};
    padding: ${({ $isGrid }) => !$isGrid ? ` ${vw(85, 'mobile')} 0 ${vw(135, 'mobile')};`: `${vw(15, 'mobile')} 0 ${vw(135, 'mobile')};`};
    grid-column: 1 / span 6;
    width: 100%;

    ${mq.greaterThan('tablet')} {
      grid-column: 1 / span 12;
      padding: ${({ $isGrid }) => !$isGrid ? `${vw(107, 'desktop')} ${vw(50, 'desktop')} ${vw(157, 'desktop')};`: `${vw(20, 'desktop')} ${vw(50, 'desktop')} ${vw(157, 'desktop')};`};
    }

    > div {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      margin: 0;
      ${mq.greaterThan('tablet')} {
        width: 52%;
        margin: 0 auto;
        //6columnes
      }
    }
  }

  figure {
    mix-blend-mode: multiply;
    height: ${vw(154, 'mobile')};
    width: ${vw(158, 'mobile')};

    ${mq.greaterThan('tablet')} {
      height: ${vw(154, 'desktop')};
      width: ${vw(158, 'desktop')};
    }
  }

  h2, p {
    text-align: center;
  }

  figure,
  h2 {
    margin-bottom: ${vw(22, 'mobile')};


    ${mq.greaterThan('tablet')} {
      margin-bottom: ${vw(22, 'desktop')};
    }

  }

  h2 {
    ${font12(true, 400)}

    ${mq.greaterThan('tablet')} {
      ${font12(false, 400)}
    }
  }

  p {
		${font15(true, 400)}
    letter-spacing: -.15px;
    max-width: unset;

    ${mq.greaterThan('tablet')} {
      ${font15(false, 400)}
      max-width: ${vw(450, 'desktop')};
    }
  }

  a {
    ${createUnderline({ reverse: true })}
  }
`
